import { render, staticRenderFns } from "./img-placeholder.vue?vue&type=template&id=6644bddc"
import script from "./img-placeholder.vue?vue&type=script&lang=js"
export * from "./img-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports